import React, { createContext, useContext, useState } from 'react';

const MessageBoxContext = createContext([]);

export function MessageBoxProvider({ children }) {
  const [messageData, setMessageData] = useState([]);
  const [messageType, setMessageType] = useState('');

  const contextValues = {
    messageData,
    messageType,
    setMessageData,
    setMessageType,
  };

  return <MessageBoxContext.Provider value={contextValues}>{children}</MessageBoxContext.Provider>;
}

export function useMessageBox() {
  return useContext(MessageBoxContext);
}
